export const REQUEST_VIDEO = 'REQUEST_VIDEO';
export const RECEIVE_VIDEO = 'RECEIVE_VIDEO';
export const REQUEST_SEARCH = 'REQUEST_SEARCH';
export const RECEIVE_SEARCH = 'RECEIVE_SEARCH';
export const RECEIVE_MORE_SEARCH = 'RECEIVE_MORE_SEARCH';
export const REQUEST_CHANNEL_INFO = 'REQUEST_CHANNEL_INFO';
export const RECEIVE_CHANNEL_INFO = 'RECEIVE_CHANNEL_INFO';
export const REQUEST_VIDEO_COMMENTS = 'REQUEST_VIDEO_COMMENTS';
export const RECEIVE_VIDEO_COMMENTS = 'RECEIVE_VIDEO_COMMENTS';
export const RECEIVE_MORE_COMMENTS = 'RECEIVE_MORE_COMMENTS';


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js